import { render, staticRenderFns } from "./VipModal.vue?vue&type=template&id=7e7fcebe"
import script from "./VipModal.vue?vue&type=script&lang=js"
export * from "./VipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports